<thead class="css-table-header-container css-table-header">
  <tr>
    <th [style.width.rem]="2.25"></th>
    <th resizable>
      <app-table-column-header
        columnName="Unit Name"
        i18n-columnName
        [odataSortProperty]="'unitName'"
        [sortString]="activeSort$ | async"
        (updateActiveSort)="updateActiveSort($event)" />
    </th>
    <th resizable>
      <app-table-column-header
        columnName="Unit ID"
        i18n-columnName
        [odataSortProperty]="'clientUnitId'"
        [sortString]="activeSort$ | async"
        (updateActiveSort)="updateActiveSort($event)" />
    </th>
    <th resizable>
      <app-table-column-header
        columnName="Category"
        i18n-columnName
        [odataSortProperty]="'designatedUnitType'"
        [sortString]="activeSort$ | async"
        (updateActiveSort)="updateActiveSort($event)" />
    </th>
  </tr>
</thead>
